import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AiCardsListGenerated from './AiCardsList/AiCardsListGenerated';
import video from '../assets/speech.mp4';
import { useAppleAuth } from '../hooks/useAppleAuth';
import './RecipeResultScreen.css';
import token from '../assets/dollar.png';
import appicon from '../assets/appIcon.png';
import PromotionalModal from './PromotionalModal/PromotionalModal';
 
// Моковый результат для неавторизованных пользователей
const mockRecipe = {
  title: "Demo Recipe Result",
  description: "This is a demo recipe result. Sign in with Apple to see real personalized recipes.",
  usedIngredients: ["Demo Ingredient 1", "Demo Ingredient 2", "Demo Ingredient 3"],
  level: "Medium",
  cooktime: "25 min",
  calories: "450 kcal",
  steps: [
    "This is a demo step 1. Sign in with Apple to access full recipe details.",
    "This is a demo step 2. You'll get real personalized recipes after signing in.",
    "This is a demo step 3. Continue with Apple to unlock all features."
  ]
};

const RecipeResultScreen = ({ recipe, onBack, isLoading: initialLoading }) => {
  const recipeFirst = recipe[0];
  const imageUrl = recipe.imageUrl;
  const [isLoading, setIsLoading] = useState(initialLoading || false);
  const [errorMessage, setErrorMessage] = useState(null);
  const { login, loading: authLoading, error: authError, user } = useAppleAuth();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [useMockRecipe, setUseMockRecipe] = useState(false);
  const [hasTriedAuth, setHasTriedAuth] = useState(false);
  
  // Добавляем обработчик события для аутентификации
  useEffect(() => {
    const handleAuthComplete = (event) => {
      const { success, user, state } = event.detail;
      
      // Проверяем состояние из события
      const shouldShowModal = state?.showModalAfterAuth || false;
      const fromRecipeScreen = state?.previousComponent === 'RecipeResultScreen';
      
      if (success && user) {
        setIsSuccess(true);
        setModalMessage('Congratulations! You have successfully registered! Claim your 126 bonus points in the app.');
        
        if (shouldShowModal || fromRecipeScreen) {
          setShowModal(true);
        }
      } else if (!success && (shouldShowModal || fromRecipeScreen)) {
        setIsSuccess(false);
        setModalMessage('Get your 96 tokens in the application.');
        setUseMockRecipe(true);
        setShowModal(true);
      }
      
      setIsLoading(false);
    };
    
    // При загрузке компонента проверяем URL параметры
    const checkURLParams = () => {
      const params = new URLSearchParams(window.location.search);
      const fromAuth = params.get('fromAuth') === 'true';
      
      if (fromAuth && user) {
        setIsSuccess(true);
        setModalMessage('Congratulations! You have successfully registered! Claim your 126 bonus points in the app.');
        setShowModal(true);
        
        // Очищаем URL от параметра
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };
    
    checkURLParams();
    window.addEventListener('appleAuthComplete', handleAuthComplete);
    
    return () => {
      window.removeEventListener('appleAuthComplete', handleAuthComplete);
    };
  }, [user]);
  
  // Наблюдаем за изменением пользователя  
  useEffect(() => {
    if (user) {
      setIsSuccess(true);
      setModalMessage('Congratulations! You have successfully registered! Claim your 126 bonus points in the app.');
      // Не показываем модалку автоматически здесь, только при получении события
    }
  }, [user]);
  
  const handleAppleSignIn = async () => {
    try {
      // Убираем реальную аутентификацию и просто показываем модальное окно
      setIsSuccess(false);
      setModalMessage('Get your 96 tokens in the application.');
      setShowModal(true);
      setUseMockRecipe(true);
      
      // Отмечаем, что была попытка аутентификации (хотя реальной попытки не было)
      setHasTriedAuth(true);
      
    } catch (error) {
      console.error('Ошибка при открытии модального окна:', error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Определяем, какой рецепт отображать (настоящий или моковый)
  const displayedRecipe = useMockRecipe ? mockRecipe : {
    ...recipeFirst,
    usedIngredients: recipeFirst.usedIngredients,
    level: recipeFirst.level,
    cooktime: recipeFirst.cooktime,
    calories: recipeFirst.calories
  };

  return (
    <div className="recipe-container fade-in">
      <div className="gradient-overlay"></div>

      <div className="video-container">
        <video 
          className="video-element"
          src={video}
          autoPlay 
          loop 
          muted 
          playsInline
        />
      </div>

      <div className="content">
        <AiCardsListGenerated
          imageUrl={imageUrl}
          recipe={displayedRecipe}
        />
      </div>

      <div className="button-container">
        <button
          className="continue-button scale-in"
          disabled={isLoading || authLoading}
          onClick={handleAppleSignIn}
        >
          {isLoading || authLoading ? 'Please wait...' : 'Continue with Apple'}
        </button>
      </div>
      
      {/* {(isLoading || authLoading) && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )} */}

      <PromotionalModal
        isSuccess={isSuccess} 
        onClose={closeModal} 
        showModal={showModal} 
      />
    </div>
  );
};

 export default RecipeResultScreen;